import * as API from "api";
import { Operation, User } from ".";
import { httpRequest } from './initialize'
import { Notifications, Subscriptions } from "store";
import { NotificationMessageType } from "store/modules/notifications";
import { IPlanInfo } from "components/presentational/views/PlanSubscription";
import { ISubscriptionOptions, CheckoutStep } from "api/ChargeBee";

export const subscribeToPlan = (plan: IPlanInfo, dispatch) => {
    const { id } = plan;
    dispatch(Subscriptions.newPlanSelected(id));
    Operation.clearUserMessages(dispatch);
    API.Analytics.planSelected(plan);

    const options: ISubscriptionOptions = {
        planId: id,
        request: httpRequest,
        onStepCompleted: onCheckoutStepCompleted
    }
    return API.ChargeBee.subscribe(options)
        .then(result => {
            if (result && result.success) {
                dispatch(Subscriptions.newSubscriptionSuccess(id))
                API.Analytics.planSubscriptionCompleted(plan, undefined, result.subscription.status);
                //Reload User Account to update subscription info
                User.loadUserInformation(dispatch).then(user => {
                    dispatch(Notifications.raiseNotification({ type: NotificationMessageType.newSubscription, title: "Plan subscription was successful" }));
                });
            }
            else {
                //ToDo: parse [result.notifications] messages for details
                throw new Error("Failed to create subscription.");
            }
        })
        .catch(err => Operation.onFail(`Failed to subscribe to plan [${id}]`, dispatch, err));
}

/* Tack the checkout selection steps */
const onCheckoutStepCompleted = (step: CheckoutStep) => {
    switch (step) {
        case CheckoutStep.cart_screen:
            API.Analytics.checkout("Subscription Plan Confirmed");
            break;
        case CheckoutStep.add_billing_address:
            API.Analytics.checkout("Billing Info Added");
            break;
        case CheckoutStep.add_payment_method:
            API.Analytics.checkout("Payment Info Confirmed");
            break;
    }
}

export const openManagementPortal = (subscriptionId, dispatch) => {
    return API.ChargeBee.portalOpen()
        .then(() => {
            //On Close of popup
            return;
        })
        .catch(err => Operation.onFail('Failed to open subscription management portal', dispatch, err));
}


// WEBPACK FOOTER //
// ./src/application/planSubscription.ts